import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;
const getDieTypeList = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/die-type/`, {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search, // You might want to include search here, if applicable
      ordering: ordering
    },
  });
};

const getDieArchiveTypeList = (page, pagesize, search) => {
    return axios.get(API_URL +'/api/'+ API_VERSION + '/die-type/?deleted=1', {headers: authHeader(), params: {
        page: page,
        pagesize: pagesize,
        search: search
    }});
};
const editDieType = (id, categoryData) => {
    return axios.patch(
      `${API_URL}/api/${API_VERSION}/die-type/${id}/`,
      categoryData, 
      { headers: authHeader() }
    );
  };
const createDieType = categoryData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/die-type/`,
    categoryData,
    {
      headers: authHeader(),
    },
  );
};
const deleteDieType = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/die-type/${id}/archive/`, // Include the die group's ID in the URL
        { headers: authHeader() } // Authentication header
    );
};
const unArchiveDieType = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/die-type/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const dieTypeService = {
  getDieTypeList,
  getDieArchiveTypeList,
  createDieType,
  editDieType,
  deleteDieType,
  unArchiveDieType
};

export default dieTypeService;
